export default __webpack_public_path__ + "static/jessica-5b0ff1db97df9bc00ad5b9cbc20c1038.jpg";